/**
 * 🤖 AUTO-GENERATED API SCHEMA FILE - DO NOT EDIT DIRECTLY!
 *
 * This file is automatically generated from entity configuration files.
 * Any manual changes will be lost when the generator runs again.
 *
 * 🔄 DATA FLOW PIPELINE:
 * 1. Entity Config (config/entities/rodeo_round_configs-entity-config.ts) → Single Source of Truth
 * 2. THIS FILE → TypeBox schemas for runtime validation + API types
 * 3. API Clients → Use these schemas for request/response validation
 * 4. React Hooks → Use these types for type-safe data fetching
 * 5. Components → Import types from this schema file
 *
 * 🛠️ TO MODIFY:
 * - Edit the entity config file: config/entities/rodeo_round_configs-entity-config.ts
 * - Run: npm run schemas:gen (regenerates this file)
 * - Or run: npm run db:full-workflow (does everything)
 *
 * 📋 ARCHITECTURE:
 * - Entity configs define field publicity, types, and validation rules
 * - TypeBox schemas provide runtime validation for API requests/responses
 * - Static types are derived from TypeBox schemas for compile-time safety
 * - Query options and response types standardize API interactions
 *
 * 🔗 RELATED FILES:
 * - config/entities/rodeo_round_configs-entity-config.ts (source configuration)
 * - scripts/generate-api-clients.ts (this generator)
 * - client/api/generated_clients/generated-rodeo_round_configs-api-client.ts (API client using these schemas)
 * - client/api/generated_hooks/rodeo_round_configs.ts (React hooks using these types)
 *
 * 🔒 SECURITY: Only fields marked as 'public: true' in the config are included
 *
 * Generated at: 2026-09-17T23:32:24.821Z
 * Source config: config/entities/rodeo_round_configs-entity-config.ts
 * Public fields: 16/16 total fields
 */

import { Type, Static } from '@sinclair/typebox';


// TypeBox schemas for runtime validation (public fields only)
export const RodeoRoundConfigsSchema = Type.Object({
  id: Type.String({ format: "uuid" }), // id field
  rodeo_id: Type.String({ format: "uuid" }), // rodeo_id field
  event_id: Type.String({ format: "uuid" }), // event_id field
  round_number: Type.Number(), // round_number field
  round_name: Type.Union([Type.String(), Type.Null()]), // round_name field
  performance_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // performance_id field
  is_go_round: Type.Boolean(), // is_go_round field
  is_short_round: Type.Boolean(), // is_short_round field
  advancing_count: Type.Union([Type.Number(), Type.Null()]), // advancing_count field
  sort_order: Type.Number(), // sort_order field
  metadata: Type.Union([Type.String(), Type.Null()]), // metadata field
  created_by: Type.Union([Type.String(), Type.Null()]), // created_by field
  created_at: Type.String({ format: "date-time" }), // created_at field
  updated_by: Type.Union([Type.String(), Type.Null()]), // updated_by field
  updated_at: Type.String({ format: "date-time" }), // updated_at field
  run_order_mode: Type.String(), // run_order_mode field
});

export const CreateRodeoRoundConfigsSchema = Type.Object({
  rodeo_id: Type.String({ format: "uuid" }), // rodeo_id field
  event_id: Type.String({ format: "uuid" }), // event_id field
  round_number: Type.Number(), // round_number field
  round_name: Type.Union([Type.String(), Type.Null()]), // round_name field
  performance_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // performance_id field
  is_go_round: Type.Optional(Type.Boolean()), // is_go_round field
  is_short_round: Type.Optional(Type.Boolean()), // is_short_round field
  advancing_count: Type.Union([Type.Number(), Type.Null()]), // advancing_count field
  sort_order: Type.Optional(Type.Number()), // sort_order field
  metadata: Type.Optional(Type.Union([Type.String(), Type.Null()])), // metadata field
  created_by: Type.Union([Type.String(), Type.Null()]), // created_by field
  updated_by: Type.Union([Type.String(), Type.Null()]), // updated_by field
  run_order_mode: Type.Optional(Type.String()), // run_order_mode field
});

export const UpdateRodeoRoundConfigsSchema = Type.Object({
  rodeo_id: Type.String({ format: "uuid" }), // rodeo_id field
  event_id: Type.String({ format: "uuid" }), // event_id field
  round_number: Type.Number(), // round_number field
  round_name: Type.Union([Type.String(), Type.Null()]), // round_name field
  performance_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // performance_id field
  is_go_round: Type.Boolean(), // is_go_round field
  is_short_round: Type.Boolean(), // is_short_round field
  advancing_count: Type.Union([Type.Number(), Type.Null()]), // advancing_count field
  sort_order: Type.Number(), // sort_order field
  metadata: Type.Union([Type.String(), Type.Null()]), // metadata field
  created_by: Type.Union([Type.String(), Type.Null()]), // created_by field
  updated_by: Type.Union([Type.String(), Type.Null()]), // updated_by field
  run_order_mode: Type.String(), // run_order_mode field
});

// TypeScript types derived from TypeBox schemas (matching server-side pattern)
export type RodeoRoundConfigsRow = Static<typeof RodeoRoundConfigsSchema>;
export type RodeoRoundConfigsInsert = Static<typeof CreateRodeoRoundConfigsSchema>;
export type RodeoRoundConfigsUpdate = Static<typeof UpdateRodeoRoundConfigsSchema>;

// Legacy type aliases for backward compatibility
export type RodeoRoundConfigs = RodeoRoundConfigsRow;
export type CreateRodeoRoundConfigs = RodeoRoundConfigsInsert;
export type UpdateRodeoRoundConfigs = Static<typeof UpdateRodeoRoundConfigsSchema>;

// Field configuration metadata
export const RodeoRoundConfigsFieldConfig = {
  filterable: ['id', 'rodeo_id', 'event_id', 'performance_id', 'run_order_mode'] as const,
  sortable: ['created_at', 'updated_at'] as const,
  searchable: [] as const,
  required: ['id', 'rodeo_id', 'event_id', 'round_number', 'is_go_round', 'is_short_round', 'sort_order', 'created_at', 'updated_at', 'run_order_mode'] as const,
  readonly: ['id', 'created_at', 'updated_at'] as const,
} as const;
